import { Switch as SwitchAntd } from "antd";
import styled from "styled-components";

export const LayoutsPreviewContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 32px;

  /* Estilos para garantir compatibilidade com antd v5 Image.PreviewGroup */
  & > .ant-image-preview-group,
  & .ant-image-preview-group {
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 14px;
    width: 100%;
  }

  & > div,
  & .ant-image-preview-group > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-direction: column;
    flex-shrink: 0;
  }

  & > div > p,
  & .ant-image-preview-group > div > p {
    font-family: "Poppins", "sans-serif";
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: #3a3a3c;
    margin: 8px 0 0 0;
  }
`;

export const PreviewWrapper = styled.div`
  border: 2px solid transparent;
  transition: all 300ms;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0);
  &:hover {
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
    border-color: #11a7d9;
  }
`;

export const Limiter = styled.div`
  width: auto;
  height: auto;
  border: 2px solid #11a7d9;
`;

export const EnlargeSwitch = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: #3a3a3c;
`;

export const Switch = styled(SwitchAntd)`
  &.ant-switch-checked {
    background-color: #11a7d9;
  }
`;
